// extracted by mini-css-extract-plugin
export default {"badge":"default__badge___cGHL0","hiddenBadge":"default__hiddenBadge___ohIF6 default__badge___cGHL0"};